export const emailTemplateRoute = {
  EMAIL_TEMPLATE_LIST: '/emailTemplate/list',
  EMAIL_TEMPLATE_DETAIL: '/emailTemplate/detail/:recordId',
};
